import { render, staticRenderFns } from "./DeviceFeedbackDetail.vue?vue&type=template&id=94dc61fa&scoped=true&"
import script from "./DeviceFeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceFeedbackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dc61fa",
  null
  
)

export default component.exports